import React, { useContext, useState } from 'react'
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import { getImages } from '../../Common/const'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-time-picker/dist/TimePicker.css';
import ReCAPTCHA from "react-google-recaptcha";
import { VehicleContext } from '../../Context/VehicleContext';

const AutomotiveJobsModal = ({ close, openLocationName }) => {
  const { submitContactForm } = useContext(VehicleContext);
  const recaptchaRef = React.useRef();

  const [date, setDate] = useState(null);
  return (
    <>
      <div className="modal-content">
        <div className="modal-header">
          <h1 className='modal-title filter-modal-title eurostile text-uppercase text-center w-100 font-1-2em'>Career Application</h1>
          <button className="sm-box-close" type="button" onClick={close}>
            <img src={getImages('white-close.svg')} />
          </button>
        </div>
        <div className="modal-body ss-pd">
          <Formik
            initialValues={{
              location: openLocationName,
              positionfor: "",
              desiredsalary: "",
              dateavailable: "",
              first_name: "",
              last_name: "",
              email: "",
              phone: "",
              address: "",
              city: "",
              state: "",
              zipcode: "",
              educationHistory: [
                {
                  schoolcity: "",
                  educationtype: "",
                  schoolname: "",
                  schoolstate: "",
                  areasstudied: "",
                  degreeearned: "",
                  startdate: null,
                  enddate: null
                }
              ],

              employerHistory: [
                {
                  employername: "",
                  employerstate: "",
                  employercity: "",
                  supervisorname: "",
                  supervisorphoneemail: "",
                  jobtitle: "",
                  jobdescription: "",
                  jobstartdate: null,
                  jobenddate: null
                }
              ],
              // employername: "",
              // employerstate: "",
              // employercity: "",
              // supervisorname: "",
              // supervisorphoneemail: "",
              // jobtitle: "",
              // jobdescription: "",
              // jobstartdate: "",
              // jobenddate: "",

              comments: "",
            }}
            // validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
              const token = await recaptchaRef.current.executeAsync();
              recaptchaRef.current.reset(); // Reset after use
      
              values.token = token;
              values.skip_adf = true;
      
              console.log(values);
              
              const data = await submitContactForm(values);
              if (data.success) {
                resetForm();
                alert("Thank you for your submission. We'll be in touch soon!");
              } else
                alert("There was a problem with your submission");
            }}
          >
            {({ values, setFieldValue, field, form }) => (
              <Form>
                <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6LckXRIsAAAAAAiOe2UBkXy7Uy-ROdiueqrr4Lzk" // Replace with your actual site key
                    size="invisible"
                /> 
                <div className="custom-form consign-form">
                  {/* Position Information and Availability */}
                  <div className="row">
                    <div className="col-12">
                      <div className="xs-title eurostile text-uppercase fw-700 mb-4">Position Information and Availability</div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <div className='cs-label mb-2'>Position Applying For</div>
                        <Field as="select" name="positionfor" className="form-control">
                          <option value="">Select</option>
                          <option value="Sales">Sales</option>
                          <option value="Administrative">Administrative</option>
                          <option value="Finance">Finance</option>
                          <option value="Service Department">Service Department</option>
                          <option value="Body Shop">Body Shop</option>
                          <option value="Parts Department">Parts Department</option>
                        </Field>
                        <ErrorMessage
                          name="positionfor"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <div className='cs-label mb-2'>Desired Salary</div>
                        <Field type="text" name="desiredsalary" className="form-control" />
                        <ErrorMessage
                          name="desiredsalary"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <div className='cs-label mb-2'>Date Available</div>
                        <Field type="text" name="dateavailable" className="form-control" />
                        <ErrorMessage
                          name="dateavailable"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Contact Info */}
                  <div className="row">
                    <div className="col-12 pt-3">
                      <div className="cs-hr"></div>
                    </div>
                    <div className="col-12">
                      <div className="xs-title eurostile text-uppercase fw-700 mb-4">Contact Info</div>
                    </div>
                  </div>
                  <div className="row mlr-35">
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className='d-flex align-items-center justify-content-between mb-2'>
                          <div className='cs-label mb-0'>Full Name</div>
                          <div className='cs-require'><span className="text-orange">*</span> Required</div>
                        </div>
                        <Field type="text" name="first_name" className="form-control" />
                        <ErrorMessage
                          name="first_name"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <div className='d-flex align-items-center justify-content-between mb-2'>
                          <div className='cs-label mb-0'>Last Name</div>
                          <div className='cs-require'><span className="text-orange">*</span> Required</div>
                        </div>
                        <Field type="text" name="last_name" className="form-control" />
                        <ErrorMessage
                          name="last_name"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <div className='d-flex align-items-center justify-content-between mb-2'>
                          <div className='cs-label mb-0'>Email</div>
                          <div className='cs-require'><span className="text-orange">*</span> Required</div>
                        </div>
                        <Field type="text" name="email" className="form-control" />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="cs-label mb-2">Phone</div>
                        <Field type="text" name="phone" className="form-control" />
                        <ErrorMessage
                          name="phone"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <div className="cs-label mb-2">Address</div>
                        <Field type="text" name="address" className="form-control" />
                        <ErrorMessage
                          name="address"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="cs-label mb-2">City</div>
                        <Field type="text" name="city" className="form-control" />
                        <ErrorMessage
                          name="city"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </div>

                    <div className="col-md-3 pe-md-3">
                      <div className="form-group">
                        <div className="cs-label mb-2">State</div>
                        <Field type="text" name="state" className="form-control" />
                        <ErrorMessage
                          name="state"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </div>

                    <div className="col-md-3 ps-md-3">
                      <div className="form-group">
                        <div className="cs-label mb-2">Zip Code</div>
                        <Field type="text" name="zipcode" className="form-control" />
                        <ErrorMessage
                          name="zipcode"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Education History */}
                  <div className='row'>
                    <div className="col-12 pt-3">
                      <div className="cs-hr"></div>
                    </div>
                    <div className="col-12">
                      <div className="xs-title eurostile text-uppercase fw-700 mb-4">Education History</div>
                    </div>
                  </div>
                  <div className="eh-rows">
                    <FieldArray name="educationHistory">
                      {({ push, remove }) => {
                        const lastIndex = values.educationHistory.length - 1;
                        return (
                          <>
                            {values.educationHistory.map((item, index) => (
                              <div key={index} className='eh-col mb-3'>
                                {/* {index === 0 && <div className="cs-hr mt-4"></div>} */}
                                <div className='row mlr-35'>
                                  {/* School City */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">School City</div>
                                      <Field
                                        type="text"
                                        name={`educationHistory.${index}.schoolcity`}
                                        className="form-control"
                                      />
                                      <ErrorMessage
                                        name={`educationHistory.${index}.schoolcity`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* Education Type */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">Education Type</div>
                                      <Field
                                        as="select"
                                        name={`educationHistory.${index}.educationtype`}
                                        className="form-control"
                                      >
                                        <option value="">Select</option>
                                        <option value="Some High School">Some High School</option>
                                        <option value="High School Graduate">High School Graduate</option>
                                        <option value="Some Vocational School">Some Vocational School</option>
                                        <option value="Vocational School Graduate">Vocational School Graduate</option>
                                        <option value="Some College">Some College</option>
                                        <option value="College Graduate">College Graduate</option>
                                      </Field>
                                      <ErrorMessage
                                        name={`educationHistory.${index}.educationtype`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* School Name */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">School Name</div>
                                      <Field
                                        type="text"
                                        name={`educationHistory.${index}.schoolname`}
                                        className="form-control"
                                      />
                                      <ErrorMessage
                                        name={`educationHistory.${index}.schoolname`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* School State */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">School State</div>
                                      <Field
                                        type="text"
                                        name={`educationHistory.${index}.schoolstate`}
                                        className="form-control"
                                      />
                                      <ErrorMessage
                                        name={`educationHistory.${index}.schoolstate`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* Areas Studied */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">Areas Studied</div>
                                      <Field
                                        type="text"
                                        name={`educationHistory.${index}.areasstudied`}
                                        className="form-control"
                                      />
                                      <ErrorMessage
                                        name={`educationHistory.${index}.areasstudied`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* Degree Earned */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">Degree Earned</div>
                                      <Field
                                        type="text"
                                        name={`educationHistory.${index}.degreeearned`}
                                        className="form-control"
                                      />
                                      <ErrorMessage
                                        name={`educationHistory.${index}.degreeearned`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* Start Date */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">Start Date</div>
                                      <DatePicker
                                        selected={item.startdate}
                                        onChange={(val) => setFieldValue(`educationHistory.${index}.startdate`, val.toISOString().split("T")[0])}
                                        className="form-control w-100 calender-icon"
                                        dateFormat="MM-dd-yyyy"
                                        placeholderText="mm/dd/yy"
                                      />
                                      <ErrorMessage
                                        name={`educationHistory.${index}.startdate`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* End Date */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">End Date</div>
                                      <DatePicker
                                        selected={item.enddate}
                                        onChange={(val) => setFieldValue(`educationHistory.${index}.enddate`, val.toISOString().split("T")[0])}
                                        className="form-control w-100 calender-icon"
                                        dateFormat="MM-dd-yyyy"
                                        placeholderText="mm/dd/yy"
                                      />
                                      <ErrorMessage
                                        name={`educationHistory.${index}.enddate`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                </div>

                                {/* Remove Button */}
                                {index > 0 && (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-danger mt-2 mb-3"
                                      onClick={() => remove(index)}
                                    >
                                      Remove
                                    </button>
                                  </>
                                )}
                                

                              </div>
                            ))}

                            {/* ADD NEW GROUP BUTTON */}
                            <button
                              type="button"
                              className="transparent-orange-btn text-uppercase"
                              onClick={() =>
                                push({
                                  schoolcity: "",
                                  educationtype: "",
                                  schoolname: "",
                                  schoolstate: "",
                                  areasstudied: "",
                                  degreeearned: "",
                                  startdate: null,
                                  enddate: null
                                })
                              }
                            >
                              <span className='icon-plus'></span> Add Prior Education
                            </button>
                          </>
                        );
                      }}
                    </FieldArray>
                  </div>


                  {/* Employment History */}
                  <div className='row'>
                    <div className="col-12 pt-3">
                      <div className="cs-hr"></div>
                    </div>
                    <div className="col-12">
                      <div className="xs-title eurostile text-uppercase fw-700 mb-4">Employment History</div>
                    </div>
                  </div>
                  <div className="eh-rows">
                    <FieldArray name="employerHistory">
                      {({ push, remove }) => {
                        const lastIndex = values.employerHistory.length - 1;
                        return (
                          <>
                            {values.employerHistory.map((item, index) => (
                              <div key={index} className='eh-col mb-3'>
                                {/* {index === 0 && <div className="cs-hr mt-4"></div>} */}
                                <div className='row mlr-35'>
                                  {/* Employer Name */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">Employer Name</div>
                                      <Field
                                        type="text"
                                        name={`employerHistory.${index}.employername`}
                                        className="form-control"
                                      />
                                      <ErrorMessage
                                        name={`employerHistory.${index}.employername`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* Employer State */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">Employer State</div>
                                      <Field
                                        type="text"
                                        name={`employerHistory.${index}.employerstate`}
                                        className="form-control"
                                      />
                                      <ErrorMessage
                                        name={`employerHistory.${index}.employerstate`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* Employer City */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">Employer City</div>
                                      <Field
                                        type="text"
                                        name={`employerHistory.${index}.employercity`}
                                        className="form-control"
                                      />
                                      <ErrorMessage
                                        name={`employerHistory.${index}.employercity`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* Supervisor Name */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">Supervisor Name</div>
                                      <Field
                                        type="text"
                                        name={`employerHistory.${index}.supervisorname`}
                                        className="form-control"
                                      />
                                      <ErrorMessage
                                        name={`employerHistory.${index}.supervisorname`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* Supervisor Phone/Email */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">Supervisor Phone/Email</div>
                                      <Field
                                        type="text"
                                        name={`employerHistory.${index}.supervisorphoneemail`}
                                        className="form-control"
                                      />
                                      <ErrorMessage
                                        name={`employerHistory.${index}.supervisorphoneemail`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* Job Title */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">Job Title</div>
                                      <Field
                                        type="text"
                                        name={`employerHistory.${index}.jobtitle`}
                                        className="form-control"
                                      />
                                      <ErrorMessage
                                        name={`employerHistory.${index}.jobtitle`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* Job Description */}
                                  <div className="col-12">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">Job Description</div>
                                      <Field
                                        as="textarea"
                                        name={`employerHistory.${index}.jobdescription`}
                                        className="form-control"
                                      />
                                      <ErrorMessage
                                        name={`employerHistory.${index}.jobdescription`}
                                        component="div"
                                        className="text-danger small"
                                      />
                                    </div>
                                  </div>

                                  {/* Job Start Date */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className="cs-label mb-2">Job Start Date</div>
                                      <DatePicker
                                        selected={item.jobstartdate}
                                        onChange={(val) =>
                                          setFieldValue(`employerHistory.${index}.jobstartdate`, val.toISOString().split("T")[0])
                                        }
                                        className="form-control w-100 calender-icon"
                                        dateFormat="MM-dd-yyyy"
                                        placeholderText="mm/dd/yy"
                                      />
                                    </div>
                                  </div>

                                  {/* Job End Date */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <div className='d-flex align-items-center justify-content-between mb-2'>
                                        <div className='cs-label mb-0'>Job End Date</div>
                                        <div className='cs-require'>Leave blank if still employed</div>
                                      </div>
                                      <DatePicker
                                        selected={item.jobenddate}
                                        onChange={(val) =>
                                          setFieldValue(`employerHistory.${index}.jobenddate`, val.toISOString().split("T")[0])
                                        }
                                        className="form-control w-100 calender-icon"
                                        dateFormat="MM-dd-yyyy"
                                        placeholderText="mm/dd/yy"
                                      />
                                    </div>
                                  </div>

                                </div>

                                {/* Remove button */}
                                {index > 0 && (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-danger mt-2"
                                      onClick={() => remove(index)}
                                    >
                                      Remove
                                    </button>
                                  </>
                                )}
                                

                              </div>
                            ))}

                            {/* Add New Employer Button */}
                            <button
                              type="button"
                              className="transparent-orange-btn text-uppercase"
                              onClick={() =>
                                push({
                                  employername: "",
                                  employerstate: "",
                                  employercity: "",
                                  supervisorname: "",
                                  supervisorphoneemail: "",
                                  jobtitle: "",
                                  jobdescription: "",
                                  jobstartdate: null,
                                  jobenddate: null
                                })
                              }
                            >
                              <span className='icon-plus'></span> Add Prior Employer
                            </button>
                          </>
                        )

                      }}
                    </FieldArray>
                  </div>


                  {/* Additional Information */}
                  <div className='row'>
                    <div className="col-12 pt-3">
                      <div className="cs-hr"></div>
                    </div>
                    <div className="col-12">
                      <div className="xs-title eurostile text-uppercase fw-700 mb-4">Additional Information</div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <div className='d-flex align-items-center justify-content-between mb-2'>
                          <div className='cs-label mb-0'>Comments</div>
                          <div className='cs-require'>Any additional information about yourself or skills that may apply</div>
                        </div>
                        <Field as="textarea" name="comments" className="form-control h-101" />
                        <ErrorMessage
                          name="comments"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </div>
                  </div>
                  <div className='text-end mt-4'>
                    <button type="submit" className="orange-white-btn lg-btn w-240 font-1-2em fw-700 text-uppercase">Send</button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>

        </div>
      </div>
    </>
  )
}

export default AutomotiveJobsModal